<header class="border-border bg-surface sticky top-0 z-20 flex h-16 shrink-0 items-center justify-between border-b px-4 sm:px-6 lg:px-8">
  <div class="flex items-center gap-3">
    <button
      type="button"
      class="hover:bg-ink/5 -ml-2 rounded-full p-2 lg:hidden"
      (click)="menuToggle.emit()">
      <app-icon
        name="menu"
        [size]="22" />
      <span class="sr-only">Abrir menú</span>
    </button>

    <div class="flex items-center gap-2 lg:hidden">
      <app-icon
        name="star"
        [size]="16"
        class="text-turquoise" />
      <span class="font-display text-ink text-base font-bold">SuperHeroes</span>
    </div>
  </div>

  <button
    type="button"
    class="hover:bg-ink/5 flex items-center gap-2 rounded-full py-1 pr-2 pl-1 transition-colors"
    [cdkMenuTriggerFor]="userMenu">
    <span class="bg-accent flex size-8 items-center justify-center rounded-full text-sm font-semibold text-white">{{ initials() }}</span>
    <app-icon
      name="chevron-down"
      [size]="16"
      class="text-muted" />
    <span class="sr-only">Menú de usuario</span>
  </button>
</header>

<ng-template #userMenu>
  <div
    cdkMenu
    class="border-border bg-surface shadow-elevated mt-2 min-w-48 overflow-hidden rounded-2xl border p-1.5">
    <a
      cdkMenuItem
      routerLink="/perfil"
      class="hover:bg-paper-dim flex items-center gap-2.5 rounded-xl px-3.5 py-2.5 text-sm font-medium transition-colors">
      <app-icon
        name="user"
        [size]="17"
        class="text-muted" />
      Ver perfil
    </a>
    <button
      cdkMenuItem
      type="button"
      (click)="onLogout()"
      class="hover:bg-paper-dim flex w-full items-center gap-2.5 rounded-xl px-3.5 py-2.5 text-left text-sm font-medium transition-colors">
      <app-icon
        name="logout"
        [size]="17"
        class="text-muted" />
      Cerrar sesión
    </button>
  </div>
</ng-template>
